export const HANDLE = "ascent-belt-bag";

export const PRODUCT = {
  handle: HANDLE,
  name: "The Ascent Athletic Belt Bag",
  price: 68,
  tagline: "One silhouette. Worn four ways.",
  description:
    "A compact, everyday belt bag with a clean rounded silhouette, a full wraparound zip and our signature silver metal MARKHOR emblem. Wear it at the waist, across the chest, over the shoulder or low on the hip.",
};

export const COLORS = [
  { id: "black", name: "Black", sku: "0R-D077-I0VU", hex: "#141414", image: "/img/bag-black.webp", life: "/img/look-black-a.webp", alt: "/img/look-black-b.webp", mood: "The original. Quiet, sharp and endlessly versatile." },
  { id: "navy", name: "Navy Blue", sku: "43-9P59-KDPJ", hex: "#1F2A44", image: "/img/bag-navy.webp", life: "/img/life-navy.webp", alt: null, mood: "Deep and composed. A softer alternative to black." },
  { id: "burgundy", name: "Burgundy", sku: "9C-CG9R-RXFZ", hex: "#7A1424", image: "/img/bag-burgundy.webp", life: "/img/look-burgundy-b.webp", alt: "/img/look-burgundy-a.webp", mood: "Rich wine tones that warm up any outfit." },
  { id: "olive", name: "Olive Green", sku: "F0-11H1-3H28", hex: "#4A5530", image: "/img/bag-olive.webp", life: "/img/look-olive-b.webp", alt: "/img/look-olive-a.webp", mood: "Earthy, grounded and made for the outdoors." },
  { id: "blush", name: "Blush Pink", sku: "6Q-16SZ-2Y1Y", hex: "#E3A3A6", image: "/img/bag-blush.webp", life: "/img/look-blush-b.webp", alt: "/img/look-blush-a.webp", mood: "A soft, confident pink with warm undertones." },
  { id: "beige", name: "Beige", sku: "9W-YKGF-L4YS", hex: "#E6DCCB", image: "/img/bag-cream.webp", life: "/img/look-cream-b.webp", alt: "/img/look-cream-a.webp", mood: "Light, calm and effortlessly clean." },
];

export const ANGLES = [
  { src: "/img/v-angle.webp", label: "Angled view" },
  { src: "/img/v-back.webp", label: "Back" },
  { src: "/img/v-side.webp", label: "Left side" },
  { src: "/img/v-side-r.webp", label: "Right side" },
  { src: "/img/v-top.webp", label: "Top" },
  { src: "/img/v-bottom.webp", label: "Bottom" },
  { src: "/img/v-inside.webp", label: "Inside" },
  { src: "/img/v-pockets.webp", label: "Interior pockets" },
  { src: "/img/v-zip.webp", label: "Zipper pull" },
  { src: "/img/v-emblem.webp", label: "Metal emblem" },
  { src: "/img/v-strap.webp", label: "Strap buckle" },
  { src: "/img/v-water.webp", label: "Water-resistant fabric" },
];

export const galleryFor = (color) => [
  { src: color.image, label: "Front", fit: "contain" },
  { src: color.life, label: "Worn", fit: "cover" },
  ...(color.alt ? [{ src: color.alt, label: "Worn", fit: "cover" }] : []),
  ...ANGLES.map((a) => ({ ...a, fit: "flush", shared: true })),
  { src: `/img/pouch-${color.id}.webp`, label: "In its pouch", fit: "flush" },
  { src: `/img/pouch-back-${color.id}.webp`, label: "Pouch, back", fit: "flush" },
];

export const getColor = (id) => COLORS.find((c) => c.id === id) ?? COLORS[0];

export const CATEGORIES = {
  all: { title: "Shop All", lead: "The complete MARKHOR collection." },
  "belt-bags": { title: "Belt Bags", lead: "Hands-free carry, cut clean for everyday movement." },
  "crossbody-bags": { title: "Crossbody Bags", lead: "The same silhouette, worn across the chest or over the shoulder." },
  "new-arrivals": { title: "New Arrivals", lead: "Collection 01 — six signature colors, just landed." },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Shop All", to: "/shop" },
  { label: "Crossbody Bags", to: "/shop/crossbody-bags" },
  { label: "Belt Bags", to: "/shop/belt-bags" },
  { label: "New Arrivals", to: "/shop/new-arrivals" },
  { label: "Our Story", to: "/our-story" },
  { label: "Coming Soon", to: "/coming-soon" },
  { label: "Contact", to: "/contact" },
];

export const COMING_SOON = [
  { id: "luggage", title: "Luggage & Travel Bags", text: "Carry-ons, duffles and weekenders built for the journey.", img: "/img/cs-luggage.webp", ratio: 0.67, logo: [72, 65], tag: "Travel" },
  { id: "men-shoes", title: "Men's Shoes", text: "Clean leather sneakers and refined loafers.", img: "/img/cs-men-shoes.webp", ratio: 1.49, logo: [57, 50], tag: "Footwear · Men" },
  { id: "women-shoes", title: "Women's Shoes", text: "Soft leather flats and sleek everyday mules.", img: "/img/cs-women-shoes.webp", ratio: 1.49, logo: [62, 46], tag: "Footwear · Women" },
  { id: "traditional-footwear", title: "Traditional Footwear", text: "Handcrafted leather sandals and embroidered slippers.", img: "/img/cs-pk-footwear.webp", ratio: 1.49, logo: [37, 41], tag: "Heritage" },
  { id: "polo", title: "Polo Shirts", text: "Premium knit polos with a modern, tailored fit.", img: "/img/cs-polo.webp", ratio: 1.31, logo: [61, 9], tag: "Clothing" },
  { id: "pants", title: "Trousers & Pants", text: "Tailored chinos and easy everyday trousers.", img: "/img/cs-pants.webp", pos: "center 28%", ratio: 1.49, logo: [87, 46], tag: "Clothing" },
];

export const MEASUREMENTS = [
  ["Size", "19 × 13 × 5 cm (7.5\" × 5\" × 2\") · W × H × D"],
  ["Strap", "Adjusts up to 106 cm (41.7\")"],
  ["Capacity", "1 L"],
];

export const FEATURES = [
  "Adjustable strap for the waist, chest or shoulder",
  "Zippered outer pocket keeps your valuables secure",
  "Interior pockets keep phone, cards and keys in their place",
  "Elastic loops neatly hold any extra strap once it's adjusted",
  "Water-repellent fabric shrugs off light rain and spills",
];

export const MATERIALS = [
  ["Body", "Recycled nylon (100%)"],
  ["Lining", "Recycled polyester (100%)"],
  ["Mesh", "Recycled polyester (100%)"],
];

export const CARE = ["Spot clean with a damp cloth and let air dry", "No machine washing or dry cleaning", "No bleach, tumble drying or ironing"];

export const RECYCLED_NOTE = "Made with 100% recycled nylon and polyester, excluding trims.";

export const SHIPPING = [
  ["Standard", "Estimated 3–7 business days within the United States"],
  ["Processing", "Typically 1–2 business days"],
  ["Free shipping", "On U.S. orders of $75 or more"],
  ["Tracking", "Tracking information is provided once your order ships"],
];

export const RETURNS = [
  ["30-day returns", "Eligible items may be returned within 30 days of delivery"],
  ["Condition", "Unused, unworn and in original condition, with tags and packaging intact"],
  ["Exchanges", "Subject to product availability"],
  ["Refunds", "Issued to the original payment method once the return is received and inspected"],
];

export const formatPrice = (n) => `$${Number(n ?? 0).toFixed(2)}`;
export const productUrl = (colorId) => `/product/${HANDLE}?color=${colorId}`;
